import { FormControl, FormControlLabel, Row, useTheme } from "@commonlibs";
import PhoneCountryCodeSelect from "../PhoneCountryCodeSelect/PhoneCountryCodeSelect";
import { PhoneInputProps, PhoneInputValue } from "./PhoneInput.types";
import { PhoneNumberField } from "./PhoneInput.styles";
import usePhoneInput from "./hooks/usePhoneInput";

const PhoneInput = ({
    country,
    Label = FormControlLabel,
    LabelProps = {},
    defaultValue = [undefined, ""],
    value,
    onChange,
    onPhoneInputChange,
    placeholder,
    showValid,
    hideError: hideErrorProp,
    required,
    onBlur,
    ...rest
}: PhoneInputProps): JSX.Element => {
    const { validation, handlePhoneInputFormControl, hideError, codeInput, setCodeInput } = usePhoneInput({
        required,
        defaultValue,
        value,
        onChange,
    });
    const { spacing } = useTheme();

    return (
        <FormControl<PhoneInputValue>
            Label={[Label, LabelProps]}
            value={codeInput}
            onChange={(value) => {
                setCodeInput(value);
                onPhoneInputChange?.(value);
            }}
            defaultValue={defaultValue}
            validation={validation}
            showValid={showValid}
            hideError={hideErrorProp || hideError}
            {...rest}
        >
            {(value, setValue, { disabled, readonly, invalid, setFocused }) => {
                const { handlePhoneCountryCodeChange, handlePhoneNumberChange, format, parse } = handlePhoneInputFormControl(
                    value,
                    setValue,
                );

                return (
                    <Row gap={spacing[3]} css={{ width: "100%" }}>
                        <PhoneCountryCodeSelect
                            country={country}
                            defaultValue={defaultValue[0]}
                            value={value[0]}
                            onChange={(val) => {
                                handlePhoneCountryCodeChange(val);
                                if (onBlur) {
                                    onBlur(value);
                                }
                            }}
                            disabled={disabled}
                            readonly={readonly}
                            error={invalid}
                            showValid={showValid}
                            hideError={hideError}
                            label=""
                        />
                        <PhoneNumberField
                            value={value[1]}
                            onChange={handlePhoneNumberChange}
                            disabled={disabled}
                            readonly={readonly}
                            placeholder={placeholder}
                            error={invalid}
                            format={format}
                            type="tel"
                            parse={parse}
                            showValid={showValid}
                            hideError={hideErrorProp || hideError}
                            onFocus={() => setFocused(true)}
                            onBlur={() => {
                                setFocused(false);
                                if (onBlur) {
                                    onBlur(value);
                                }
                            }}
                        />
                    </Row>
                );
            }}
        </FormControl>
    );
};

export default PhoneInput;
